import R from 'ramda';
import React, { Component } from 'react';
import { Row, Col, FormGroup, Radio, FormControl } from 'react-bootstrap';
import { USStates } from '../../constants';
import FontAwesome from 'react-fontawesome';
import getContent from '../ContractBlock/Contents/GoverningLaw';
import Select from '../Select';
import ChangeRequestsView from '../Deals/DealEditPages/ChangeRequestsView';

export default class GoverningLaw extends Component {
  constructor(props) {
    super(props);
    this.state = {
      adjust: undefined,
      changes: {},
      showRegionInput: false,
    };
  }

  options = () => ({
    field1: this.state.changes.field1,
    type: 'state',
  });

  componentDidMount() {
    if (this.props.dealBlocks) {
      this.getBlockChanges(this.props.dealBlocks);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.dealBlocks) {
      this.getBlockChanges(nextProps.dealBlocks);
    }
  }

  getBlockChanges(dealBlocks) {
    const block = R.find(R.propEq('id', this.props.block.id))(dealBlocks);
    if (block) {
      this.setState({
        changes: block.changes || {},
        adjust: block.accept ? !block.accept : block.changes ? true : undefined,
      });
    }
  }

  handleAdjust(adjust) {
    this.setState({ adjust });

    if (!adjust) {
      this.props.removeBlockChanges(this.props.block.id);
    }
  }

  handleContent(e) {
    let options = this.options();

    this.setState({ showRegionInput: e.target.value === 'extra_region' });

    options.type = e.target.value === 'extra_region' ? 'region' : 'state';
    options.field1 = e.target.value;
    this.props.setBlockChanges({
      id: this.props.block.id,
      options,
      ...getContent(options),
    });
  }

  handleChangeRegion(e) {
    let options = this.options();

    options.type = 'region';
    options.field1 = e.target.value || 'extra_region';
    this.props.setBlockChanges({
      id: this.props.block.id,
      options,
      ...getContent(options),
    });
  }

  renderAdjust() {
    const { adjust, changes, showRegionInput } = this.state;

    if (adjust === true) {
      let value = changes.field1;
      if (value && !USStates.includes(value)) {
        value = 'extra_region';
      }

      return (
        <div className="inner-content">
          <FormGroup className="answer">
            <Select
              className="form-control"
              value={value}
              onChange={(e) => this.handleContent(e)}
            >
              <option value="">Please select</option>
              <option value="extra_region">Other</option>
              {USStates.map((state, i) => (
                <option key={i}>{state}</option>
              ))}
            </Select>

            {(showRegionInput || value === 'extra_region') && (
              <FormControl
                type="text"
                className="form-control region-input"
                placeholder="Input region"
                value={changes.field1 === 'extra_region' ? '' : changes.field1}
                onChange={(e) => this.handleChangeRegion(e)}
              />
            )}
          </FormGroup>
        </div>
      );
    } else {
      return null;
    }
  }

  renderChangeRequests() {
    return (
      <ChangeRequestsView
        changeRequests={this.props.changeRequests}
        renderChangeRequest={(changeRequest) => changeRequest.changes.field1}
      />
    );
  }

  render() {
    let value = this.state.changes.field1;
    if (value && !USStates.includes(value)) {
      value = 'extra_region';
    }

    return (
      <div className="tab-content">
        <Row>
          {!this.props.finalized && !this.props.isAttorney && (
            <Col sm={12}>
              <p className="question">
                Under which region’s law should the terms of this agreement be
                governed?
              </p>
              <FormGroup className="answer">
                <Radio
                  name="governing-adjust"
                  checked={this.state.adjust === false}
                  readOnly
                  onClick={(e) => this.handleAdjust(false)}
                >
                  {this.props.userInfo.same
                    ? `Keep my original proposal: `
                    : `Accept ${this.props.userInfo.name} 's proposed terms: `}
                  {this.props.field1}
                </Radio>
                <hr />
                <Radio
                  name="governing-adjust"
                  checked={this.state.adjust === true}
                  readOnly
                  onClick={(e) => this.handleAdjust(true)}
                >
                  {this.props.userInfo.same
                    ? `Change my proposal:`
                    : `Suggest an alternative:`}
                </Radio>
              </FormGroup>
              {this.renderAdjust()}
              {this.props.renderAccepts()}
              {this.renderChangeRequests()}
            </Col>
          )}
          {!this.props.finalized && !this.props.isAttorney && (
            <Col sm={12}>{this.props.children}</Col>
          )}

          <Col sm={12}>
            <div className="notes">
              <h4>
                <FontAwesome name="question-circle" />
                Need Some Help?
              </h4>
              <div className="expand" tabIndex="0">
                <p className="question">Why is this important?</p>
                <p className="small">
                  Your agreement will be interpreted according to the laws of
                  the region that you choose here. If a dispute arises, it will
                  be initially submitted to a court of law in this region too.
                  Typically, the region in which you live is chosen for
                  convenience, but you can choose any region that you want.
                </p>
              </div>
            </div>
          </Col>
        </Row>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// src/components/DealContractBlock/GoverningLaw.jsx